export const COLUMN_OPTIONS = (t) => {
  return {
    column1: {
      name: t("analysisColumn.date"),
      key: "date",
      isMandatory: true,
      dropdown: true,
    },
    column3: {
      name: t("analysisColumn.feedTemperature"),
      unit: "temperature",
      key: "feed_temp",
      isMandatory: true,
      dropdown: true,
    },
    // column5: {
    //   key: "feed_flowrate",
    //   name: t("analysisColumn.feedFlowrate"),
    //   unit: "flow",
    //   dropdown: true,
    // },
    // column2: {
    //   name: t("analysisColumn.filtrateFlowrate"),
    //   unit: "flow",
    //   key: "filtrate_flowrate",
    //   dropdown: true,
    // },
    column9: {
      name: t("analysisColumn.feedSuspended"),
      unit: "feed_suspended",
      key: "feed_suspended",
      dropdown: true,
    },
    // column4: {
    //   name: t("analysisColumn.permeatePressure"),
    //   unit: "pressure",
    //   key: "permeate_pressure",
    // },
    // column7: {
    //   name: t("analysisColumn.feedPressure"),
    //   unit: "pressure",
    //   key: "feed_pressure",
    // },
    column6: {
      name: t("analysisColumn.filtrateSuspended"),
      unit: "filtrate_suspended",
      key: "filtrate_suspended",
      dropdown: true,
    },
    column8: {
      key: "column8",
      isMandatory: true,
      name: t("analysisColumn.selectPressure"),
      dropdown: false,
      options: {
        option1Text: {
          name: t("analysisColumn.feed&filtratePressure"),
          unit: "pressure",
          key: "feed_pressue&filtrate_pressure",
          key1: "feed_pressure",
          key2: "filtrate_pressure",
          name1: t("analyseData.feedPressure"),
          name2: t("analyseData.filtratePressure"),
        },
        option2Text: {
          name: t("analysisColumn.tmpDrop"),
          unit: "pressure",
          key: "tmp_drop",
        },
      },
    },
    column88: {
      key: "column88",
      isMandatory: true,
      name: t("analysisColumn.selectFlow"),
      dropdown: false,
      checkboxOptions: {
        option1Text: {
          name: t("analysisColumn.feedFlowrate"),
          unit: "flow",
          key: "feed_flowrate",
        },
        option2Text: {
          name: t("analysisColumn.filtrateFlowrate"),
          unit: "flow",
          key: "filtrate_flowrate",
        },
      },
    },
  };
};

export const NORMALIZATION_COLUMN_OPTIONS = (t) => {
  return {
    column10: {
      name: t("analysisColumn.normalizedFiltrateFlow"),
      unit: "flow",
      key: "norm_filtrate_flow",
    },
    column11: {
      name: t("analysisColumn.normalizedTmp"),
      unit: "pressure",
      key: "norm_tmp",
    },

    // column12: {
    //   name: t("analysisColumn.normalizedSaltPassage"),
    //   key: "norm_salt_passage",
    // },
  };
};

const createArray = (number, key, create) => {
  let arr = [];
  if (create !== "") {
    if (key === "sel_rack") arr.push("All");
    if (number) {
      for (let i = 1; i <= number; i++) {
        arr.push(i.toString());
      }
    } else arr.push("1");
  }
  return arr;
};
export const TRAIN_OPTIONS = (t, config, selectedTrain) => {
  //  handle undefined/null config or missing trains
  const trains = config && Array.isArray(config.trains) ? config.trains : [];
  const trainIdx =
    typeof selectedTrain === "number" && selectedTrain >= 0 ? selectedTrain : 0;
  return {
    train: {
      name: t("addNewPlant.sel_train"),
      key: "sel_train",
      options: createArray(trains.length, "sel_train", true),
      isSelect: true,
    },
    rack: {
      name: t("addNewPlant.sel_rack"),
      key: "sel_rack",
      options:
        trains[trainIdx] && trains[trainIdx].racks
          ? createArray(trains[trainIdx].racks.length, "sel_rack", trainIdx)
          : [],
      isSelect: true,
    },
    pressureVessels: {
      name: t("addNewPlant.noModulePerRack"),
      key: "sel_modules_per_rack",
    },
    elementsInvolved: {
      name: t("addNewPlant.noActiveAreaInvolved"),
      key: "sel_active_area",
    },
    elementsType: {
      name: t("addNewPlant.moduleType"),
      key: "sel_module_used",
    },
  };
};
export const SEGMENT_OPTIONS = (t) => {
  return {
    dataSegmentation: {
      name: t("addNewPlant.dataSegmentation"),
      key: "sel_segment",
    },
  };
};
export const REFERENCE_CONDITION_OPTIONS = (
  t,
  selectedRadioColumn,
  selectedCheckColumn
) => {
  return {
    column12: {
      name: t("analysisColumn.feedFlowrate"),
      unit: "flow",
      key: "feed_flowrate",
      isMandatory: true,
      hide:
        selectedCheckColumn.column88.length === 1 &&
        selectedCheckColumn.column88[0] === "filtrate_flowrate",
    },
    column13: {
      name: t("analysisColumn.filtrateFlowrate"),
      unit: "flow",
      key: "filtrate_flowrate",
      isMandatory: true,
      hide:
        selectedCheckColumn.column88.length === 1 &&
        selectedCheckColumn.column88[0] === "feed_flowrate",
    },

    column14: {
      name: t("analysisColumn.feedPressure"),
      unit: "pressure",
      key: "feed_pressure",
      isMandatory: true,
      hide:
        selectedRadioColumn && selectedRadioColumn.column8 === "tmp_drop"
          ? true
          : false,
    },
    // column15: {
    //   name: t("analysisColumn.permeatePressure"),
    //   unit: "pressure",
    //   key: "permeate_pressure",
    // },
    column19: {
      name:
        selectedRadioColumn &&
        selectedRadioColumn.column8 === "feed_pressue&filtrate_pressure"
          ? t("analysisColumn.filtratePressure")
          : selectedRadioColumn.column8 === "tmp_drop"
          ? t("analysisColumn.tmpDrop")
          : t("analysisColumn.tmpDrop"),
      unit:
        selectedRadioColumn && selectedRadioColumn.column8 === "tmp_drop"
          ? "pressure"
          : selectedRadioColumn.column8 === "filtrate_pressure"
          ? "pressure"
          : "pressure",
      key:
        selectedRadioColumn && selectedRadioColumn.column8 === "tmp_drop"
          ? "tmp_drop"
          : selectedRadioColumn.column8 === "feed_pressue&filtrate_pressure"
          ? "filtrate_pressure"
          : "tmp_drop",

      isMandatory: true,
    },
    column16: {
      name: t("analysisColumn.feedTemperature"),
      unit: "temperature",
      key: "feed_temp",
      isMandatory: true,
    },
    column17: {
      name: t("analysisColumn.filtrateSuspended"),
      unit: "filtrate_suspended",
      key: "filtrate_suspended",
    },

    column18: {
      name: t("analysisColumn.feedSuspended"),
      unit: "feed_suspended",
      key: "feed_suspended",
    },
  };
};

// Minimum Settings config for only time1 and time2 fields
export const MINIMUM_SETTINGS_OPTIONS = (t) => ({
  time1: {
    name: t("advanceSettings.time1"),
    key: "time1",
  },
  time2: {
    name: t("advanceSettings.time2"),
    key: "time2",
  },
});

// extract all possible mapping keys from COLUMN_OPTIONS config
export const extractAllColumnMappingKeys = (
  columns,
  normalizedColumns,
  trainOptions,
  segmentOptions
) => {
  const keys = new Set();
  Object.values(columns).forEach((col) => {
    if (col.key) keys.add(col.key);
    if (col.options) {
      Object.values(col.options).forEach((opt) => {
        if (opt.key) keys.add(opt.key);
        if (opt.key1) keys.add(opt.key1);
        if (opt.key2) keys.add(opt.key2);
      });
    }
    if (col.checkboxOptions) {
      Object.values(col.checkboxOptions).forEach((opt) => {
        if (opt.key) keys.add(opt.key);
      });
    }
  });
  // Add normalized columns keys
  if (normalizedColumns) {
    Object.values(normalizedColumns).forEach((col) => {
      if (col.key) keys.add(col.key);
    });
  }
  // Add train options keys
  if (trainOptions) {
    Object.values(trainOptions).forEach((col) => {
      if (col.key) keys.add(col.key);
    });
  }
  // Add segment options keys
  if (segmentOptions) {
    Object.values(segmentOptions).forEach((col) => {
      if (col.key) keys.add(col.key);
    });
  }
  // Remove internal keys that should not be sent in the payload
  const internalKeys = [
    "feed_pressue&filtrate_pressure",
    "column8",
    "column88",
  ];
  return Array.from(keys).filter((key) => !internalKeys.includes(key));
};
